import TextWithCheck from './TextWithCheck'

export default TextWithCheck
